import { render } from "./NaverAuthGuidMtt.vue?vue&type=template&id=0f244764"
const script = {}

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__